/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';
import _ from 'lodash';
import axios from 'axios';
import $ from 'jquery';

class optionsModel {

    constructor(params) {
        // Profile
        this.componentName = ko.observable("job-list");
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(false);

        this.viewExpertOptions = ko.observable(false);

        ko.components.register('inline-style-editor', require('../options/inLineStyleEditor/inLineStyleEditor').default);
        

        this.context.eventManager.subscribe((navObj) =>{
            this.handleNavChanged(navObj);
        },this, "navChanged");

    }

    handleNavChanged(navObj) {
        
        console.log("nav-options: handleNavChanged");
        console.log(navObj);

        if(navObj == 'options')
        {
            this.visible(true);
            console.log("nav-options:handleNavChanged: context.profileObject(): %o", this.context.profileObject());
            console.log("nav-options:handleNavChanged: context.profileObject().disableExpertOptions: %o", this.context.profileObject().disableExpertOptions);
        }
        else
        {
            this.visible(false);
        }

    }

    toggleViewExpertOptions() {
        this.viewExpertOptions(!this.viewExpertOptions());
    }

}

export default { viewModel: optionsModel, template: require('!raw-loader!./nav-options.html') };


// WEBPACK FOOTER //
// ./src/components/nav-options/nav-options.js